import Immutable from 'seamless-immutable';
import { SET_SELECTED_REASON_ID } from './actions/blocklist.allowlist.actions';
export var INITIAL_STATE = Immutable({
  selectedReasonId: null
});
export default function blocklistAllowlistReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SET_SELECTED_REASON_ID:
      return state.set('selectedReasonId', payload);
    default:
      return state;
  }
}